import { render } from "./CouplesTherapyPage.vue?vue&type=template&id=e59bcdb6&scoped=true"
import script from "./CouplesTherapyPage.vue?vue&type=script&lang=js"
export * from "./CouplesTherapyPage.vue?vue&type=script&lang=js"

import "./CouplesTherapyPage.vue?vue&type=style&index=0&id=e59bcdb6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e59bcdb6"]])

export default __exports__